<template>
	<div class="Footer">
		<div class="score-footer">
			<el-row>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<!-- <div class="nav_logo">
						NymbleUp
					</div> -->
					<!-- <div class="nav_logo"> -->
						<router-link tag="a" to="/" exact style="color: #e29d5a; text-decoration: none;" class="nav_logo">
							<img src="../assets/images/footer_logo.png" alt="Nymbleup" width="120" />
						</router-link>
					<!-- </div> -->

					<h2 class="main-menu-tile mt-6" style="margin-bottom: 0px;">
						<div style="line-height: 1.8;">Connect with us</div>
					</h2>

					<div class="sub-menu-list mt-2">
						<div style="margin-bottom: 0px; display: flex;">
							<div style="line-height: initial;">
								<img src="../assets/images/footer/email.png" style="width: 18px;">
							</div>
							&nbsp;&nbsp;&nbsp;
							<div style="line-height: initial;">
								<a class="link-text" href="mailto:connect@nymbleup.com">connect@nymbleup.com</a>
							</div>
						</div>
						<div style="margin-bottom: 0px; display: flex;">
							<div style="line-height: initial;">
								<img src="../assets/images/footer/phone-call.png" style="width: 18px;">
							</div>
							&nbsp;&nbsp;&nbsp;
							<div style="line-height: initial;">
								<a class="link-text" href="tel:+919619502715">+91 9619502715</a>
							</div>
						</div>
					</div>
				</el-col>

				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<h2 class="main-menu-tile">
						Company
					</h2>
					<div class="mt-5">
						<div class="sub-menu-list">
							<!-- <div class="cursor-pointer" @click="redirectToPage('/about-us')">About Us</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/about-us"
									style="color: #4d4d4d; text-decoration: none;"
								>About Us</router-link>
							</div>
							<!-- <div class="cursor-pointer" @click="redirectToPage('/terms-of-service')">Terms of Service</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/terms-of-service"
									style="color: #4d4d4d; text-decoration: none;"
								>Terms of Service</router-link>
							</div>
							<!-- <div class="cursor-pointer" @click="redirectToPage('/privacy-policy')">Privacy Policy</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/privacy-policy"
									style="color: #4d4d4d; text-decoration: none;"
								>Privacy Policy</router-link>
							</div>
							<!-- <div class="cursor-pointer" @click="redirectToPage('/sitemap')">Sitemap</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/sitemap"
									style="color: #4d4d4d; text-decoration: none;"
								>Sitemap</router-link>
							</div>
						</div>
					</div>
				</el-col>

				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<h2 class="main-menu-tile">
						Solutions
					</h2>
					<div class="mt-5">
						<div class="sub-menu-list">
							<!-- <div class="cursor-pointer" @click="() => $router.push({ name: 'aiForecasting&RecommendationEngine' })">Forecasting and Recommendation Engine</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/ai-forecasting-and-reco-engine"
									style="color: #4d4d4d; text-decoration: none;"
								>Forecasting and Recommendation Engine</router-link>
							</div>
							<!-- <div class="cursor-pointer" @click="() => $router.push({ name: 'workForceScheduling' })">Workforce Management and Scheduling</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/workforce-scheduling"
									style="color: #4d4d4d; text-decoration: none;"
								>Workforce Management and Scheduling</router-link>
							</div>
							<!-- <div>End-to-end Capabilities</div> -->
							<!-- <div class="cursor-pointer" @click="() => $router.push({ name: 'demandPlanning' })">Demand Planning</div> -->
							<div class="cursor-pointer">
								<router-link
									tag="a"
									to="/demand-planning"
									style="color: #4d4d4d; text-decoration: none;"
								>Demand Planning</router-link>
							</div>
							<div>Expiry Tracking and Management</div>
						</div>
					</div>
				</el-col>

				<!-- <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
					<h2 class="main-menu-tile">
						Legal
					</h2>
					<div class="mt-5">
						<ul class="sub-menu-list">
							<li>Privacy Commitment</li>
							<li>Code of Conduct</li>
							<li>Terms of Use</li>
							<li>Privacy Policy</li>
							<li>Labor Condition Applications</li>
						</ul>
					</div>
				</el-col> -->
			</el-row>

			<div class="faded-border-bottom mt-5 mb-2">&nbsp;</div>

			<div class="copy-right">
				<div>©{{ moment().format('YYYY') }} Nymbleup. All rights reserved.</div>
				<!-- <div class="social-icons">
					<img src="../assets/images/footer/linkedin.png">
					<img src="../assets/images/footer/fb.png">
					<img src="../assets/images/footer/instagram.png">
					<img src="../assets/images/footer/twitter.png">
				</div> -->
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
export default {
	name: "Footer",
	components: {},
	mixins: [],
	props: [],
	data() {
		return {
			moment: moment
		};
	},
	methods: {
		redirectToPage(page_name) {
			this.$router.push({ path: page_name }).catch(()=>{});
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../assets/css/variable.scss";
.Footer {
	background: #fff;
	.score-footer{
		padding: 40px 80px 10px 80px;
		// border-bottom: 1px solid #fff;
	}

	.nav_logo {
		color: #E29D5A;
		cursor: pointer;
		font-size: 25px;
		font-weight: bold;
	}

	.footer-btn{
		border: 1px solid #e29d5a;
		background-color: #e29d5a;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		padding: 5px;
		height: 40px;
		width: 135px;
		-webkit-transition: .3s;
		transition: .3s;
	}

	.faded-border-bottom{
		display: block;
		border: none;
		color: #fff;
		height: 1px;
		background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 600, from(#ddd), to(#fff));
	}

	.copy-right{
		display: flex;
		align-items: center;
		justify-content: center;
		// border-top: 1px solid #ddd;
		padding: 15px 0;
		color: #e29d5a;
		font-size: 13px;
		font-weight: 600;
	}

	.social-icons{
		img {
			width: 18px;
			margin: 0 5px;
			cursor: pointer;
			-webkit-transition: -webkit-transform .2s;
			transition: -webkit-transform .2s;
			transition: transform .2s;
			transition: transform .2s, -webkit-transform .2s;
		}
		img:hover{
			-webkit-transform: scale(1.1);
			transform: scale(1.1);
		}
	}

	.nav__logo {
		font-family: $karla-bold;
		color: #E29D5A;
		cursor: pointer;
		font-size: 24px;
		font-weight: bold;
	}

	.main-menu-tile{
		font-size: 15px;
		line-height: 15px;
		text-align: left;
		color: #4d4d4d;
		margin-bottom: 20px;
	}

	.sub-menu-list{
		padding-left: 0px;
		div{
			width: fit-content;
			font-weight: 500;
			font-size: 14px;
			line-height: 24px;
			text-align: left;
			color: #4d4d4d;
			display: block;
			margin-bottom: 10px;
		}
	}
	// .main-menu-tile::after{
	// 	position: absolute;
	// 	bottom: -28px;
	// 	left: 50%;
	// 	width: 100%;
	// 	height: 1px;
	// 	margin-bottom: 20px;
	// 	content: "";
	// 	transform: translateX(-50%);
	// 	background-color: #fff;
	// }
}
@media screen and (max-width: 768px) {
	.Footer {
		.score-footer{
			padding: 40px 10px 10px 10px;
			text-align: center;

			.main-menu-tile{
				margin-top: 15px;
			}

			.sub-menu-list{
				list-style: none;
				margin: 5px 0;
			}
		}
	}
}
.link-text {
	text-decoration: none;
	color: initial;
}
</style>
